import { setObservableConfig } from "recompose";
import { from } from "rxjs";

setObservableConfig({
  fromESObservable: from
});
